import { CustomerBill } from "protobuf/billing_service_pb";
import {BillingState, BillingAction, CustomerBillingItem} from "types/store";

const initialState: BillingState = {
    bill: undefined,
    totalBill: "PKR 0",
    netSwaps: 0,
};

export default function billingReducer(
    state: BillingState = initialState,
    action: BillingAction
): BillingState {
    switch (action.type) {
        case "SET_BILL":
          return action.payload
            ? { ...state, bill: action.payload }
            : { ...initialState }; // Reset to initial state if payload is null
        case "SET_TOTAL_BILL":
          return {
            ...state,
            totalBill: action.payload || "PKR 0",
          };
           case "SET_NET_SWAPS":
          return {
            ...state,
            netSwaps: action.payload || 0,
          };
        case "SET_PACKAGE_LIST":
            return {
                ...state,
                packages: action.payload,
            };
        case "SET_PLAN_LIST":
            return {
                ...state,
                plans: action.payload,
            };
        case "SET_SUBSCRIPTION_GROUPS":
            return {
                ...state,
                subscriptionGroups: action.payload,
            };
        default:
          return state;
      }
}
